/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ICONS from "../../../../assets/Icons/index.js";
import {
  beneficiaryTransactionsDetailsById,
  resetBeneTransactionsApproval,
  resetBeneTransactionsReject,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA/index.jsx";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";

const BeneficiaryTransactionMultiApprovalCard = ({
  data,
  selectedTransactions,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SetBeneTxnDetailsId,
  setTxnId,
  openBeneTxnDetailModal,
  isDrawerOpen,
  setisDrawerOpen,
  setBeneAccountStatus,
  filterRef,
}) => {
  const dispatch = useDispatch();
  const { handleSingleSelect } = useMultiSelect();
  const {
    beneficiaryTransactionsApproveError,
    beneficiaryTransactionsRejectError,
  } = useSelector((state) => state?.beneficiaryTransactions);

  useEffect(() => {
    dispatch(resetBeneTransactionsReject());
    dispatch(resetBeneTransactionsApproval());
  }, [beneficiaryTransactionsApproveError, beneficiaryTransactionsRejectError]);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--settled)";
    }
  };

  const SideDrawerOpen = async (id, txnId, status) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
    setBeneAccountStatus(status);
    await dispatch(beneficiaryTransactionsDetailsById({ id: txnId }));
  };

  const handleCardClick = (transaction) => {
    if (transaction.beneficiary_account_approval_status === "approved") {
      handleSingleSelect(
        selectedSendTransactions,
        setSelectedSendTransactions,
        PaginationConfiguration.paginationSmall,

        { ...transaction, id: transaction?.txn_id },
      );
    }
  };

  return (
    <>
      <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
        {data?.map((transaction) => {
          return (
            <CardContainer
              filterRef={filterRef}
              varaint="overlay"
              hoverHeight={
                GlobalConfiguration?.beneTxnMultiApprovalCardHoverHeight
              }
              isDisabled={
                transaction.beneficiary_account_approval_status === "pending"
                  ? true
                  : false
              }
              key={transaction?.txn_id}
              isSelected={selectedTransactions.includes(transaction.txn_id)}
              onClickHandler={() => handleCardClick(transaction)}
            >
              <card-body>
                <TextWithIcon
                  type={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Text"
                      : "Amount"
                  }
                  fontWeight={"semibold"}
                  text={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Account approval pending"
                      : transaction?.amount
                  }
                  textColor={getStatusColor(
                    transaction.beneficiary_account_approval_status,
                  )}
                  subText={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Account status"
                      : "Amount"
                  }
                  iconComponentArray={
                    transaction.beneficiary_account_approval_status !==
                    "pending"
                      ? [
                          ...(transaction?.confidential_transaction === "Y"
                            ? [
                                {
                                  icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                  title: "confidential",
                                  isDisabled: false,
                                },
                              ]
                            : []),

                          {
                            icon: selectedTransactions.includes(
                              transaction?.txn_id,
                            )
                              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                              : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                            isDisabled: false,
                          },
                        ]
                      : []
                  }
                />
                <TextWithIcon
                  type={"Text"}
                  fontWeight={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "var(--font-normal)"
                      : "var(--font-semibold)"
                  }
                  text={transaction.beneficiary_account_name}
                  textColor={"var(--text-primary)"}
                  subText="Beneficiary name"
                />
                <TextWithCTA
                  btnText={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Approve account"
                      : "Addtional details"
                  }
                  enabledBgColor={"var(--text-primary)"}
                  enabledTextColor={"var(--primary-bg)"}
                  handleFunction={(e) => {
                    e.stopPropagation();

                    if (!sessionStorage.getItem("q2p_token")) {
                      setisDrawerOpen(false);

                      return;
                    }
                    if (
                      transaction.beneficiary_account_approval_status ===
                      "pending"
                    ) {
                      SideDrawerOpen(
                        transaction?.beneficiary_account_id,
                        transaction?.txn_id,
                        transaction?.beneficiary_account_approval_status,
                      );
                    } else {
                      openBeneTxnDetailModal();
                      setTxnId(transaction.txn_id);
                    }
                  }}
                  icon={ICONS?.ARROW_RIGHT_WHITE}
                  text={
                    transaction.created_on
                      ? formatDateViewAll(transaction.created_on, false, false)
                      : "Not given"
                  }
                  subText="Date"
                />
              </card-body>
              <card-hover>
                <TextWithIcon
                  text={transaction?.labels?.join(", ") || "No labels assigned"}
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                  iconComponentArray={[
                    {
                      icon: ICONS?.LABEL,
                    },
                  ]}
                />
              </card-hover>
            </CardContainer>
          );
        })}
      </div>
    </>
  );
};

export default BeneficiaryTransactionMultiApprovalCard;
